import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  User,
  Video,
  Package,
  Calendar,
  Settings,
  ChevronRight,
} from "lucide-react";
import { cn } from "@/lib/utils";

interface VendorVideoSidebarProps {
  isOpen: boolean;
}

const VendorVideoSidebar: React.FC<VendorVideoSidebarProps> = ({ isOpen }) => {
  const location = useLocation();
  
  const menuItems = [
    {
      title: "Dashboard",
      href: "/vendor-video-dashboard",
      icon: <LayoutDashboard className="h-5 w-5" />,
    },
    {
      title: "Profile",
      href: "/vendor-video-dashboard/profile",
      icon: <User className="h-5 w-5" />,
    },
    {
      title: "Packages",
      href: "/vendor-video-dashboard/packages",
      icon: <Package className="h-5 w-5" />,
    },
    {
      title: "Events",
      href: "/vendor-video-dashboard/events",
      icon: <Calendar className="h-5 w-5" />,
    },
    {
      title: "Finance",
      href: "/vendor-video-dashboard/finance",
      icon: <Settings className="h-5 w-5" />,
    },
    {
      title: "Settings",
      href: "/vendor-video-dashboard/settings",
      icon: <Settings className="h-5 w-5" />,
    },
  ];

  const isActive = (path: string) => {
    if (path === '/vendor-video-dashboard') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <aside 
      className={cn(
        "bg-slate-900 dark:bg-gray-950 border-r border-slate-800 dark:border-gray-800 transition-all duration-300 shadow-lg",
        isOpen ? "w-64" : "w-20"
      )}
    >
      <div className="flex flex-col h-full">
        <div className="p-5 border-b border-slate-800 dark:border-gray-800">
          <div className={cn(
            "text-xl font-bold text-white flex items-center",
            isOpen ? "justify-start" : "justify-center"
          )}>
            {isOpen ? (
              <span className="font-heading text-secondary">Video Vendor</span>
            ) : (
              <span className="font-heading text-secondary">VV</span>
            )}
          </div>
        </div>
        
        <nav className="flex-1 overflow-y-auto py-4">
          <ul className="space-y-1 px-3">
            {menuItems.map((item) => (
              <li key={item.title}>
                <Link
                  to={item.href}
                  className={cn(
                    "flex items-center py-2 px-3 rounded-md text-sm transition-colors",
                    isActive(item.href)
                      ? "bg-secondary/20 text-secondary-foreground hover:bg-secondary/30"
                      : "text-slate-300 dark:text-gray-300 hover:bg-slate-800/60 dark:hover:bg-gray-800/60"
                  )}
                >
                  <div className={cn(
                    "flex items-center",
                    isOpen ? "justify-start w-full" : "justify-center"
                  )}>
                    {item.icon}
                    {isOpen && (
                      <>
                        <span className="ml-3 font-medium">{item.title}</span>
                        {isActive(item.href) && (
                          <ChevronRight className="h-4 w-4 ml-auto text-secondary" />
                        )}
                      </>
                    )}
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default VendorVideoSidebar;